import { OpenSkyFlightResult } from "@flights/types";

export type State = OpenSkyFlightResult[] | null;

export const getInitialState = (): State => null;
